export default __webpack_public_path__ + "static/media/A4_ORI.838b36f8.png";